export default __webpack_public_path__ + "static/media/fridge1-before1-1920w.9a2d8a4e.webp";